(function(){
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function once(el){ if(el.dataset.on) return false; el.dataset.on = '1'; return true; }
  function kr(v){ return Math.round(v).toLocaleString('sv-SE') + ' kr'; }
  function stopper(el){ var s = { v: false }; ['pointerdown','keydown','focusin'].forEach(function(e){ el.addEventListener(e, function(ev){ if(ev.isTrusted) s.v = true; }); }); return s; }
  function init(root){
    root.querySelectorAll('[data-skd-qb]').forEach(function(q){
      if(!once(q)) return;
      var labels = q.querySelectorAll('label'), btn = q.querySelector('[data-total]'), st = stopper(q), i = 0;
      function sel(l){ labels.forEach(function(x){ x.classList.toggle('is-on', x === l); }); var inp = l.querySelector('input'); inp.checked = true; btn.textContent = 'Lägg i varukorgen – ' + kr(+inp.getAttribute('data-sum')); }
      labels.forEach(function(l){ l.addEventListener('click', function(){ sel(l); }); });
      sel(labels[0]);
      if(reduce) return;
      setInterval(function(){ if(st.v) return; i = (i + 1) % labels.length; sel(labels[i]); }, 1800);
    });
    root.querySelectorAll('[data-skd-bun]').forEach(function(b){
      if(!once(b)) return;
      var cbs = b.querySelectorAll('input'), imgs = b.querySelectorAll('.skd-bun__img'), sum = b.querySelector('[data-sum]'), save = b.querySelector('[data-save]'), off = +b.getAttribute('data-off') / 100, st = stopper(b), k = 1;
      function upd(){
        var t = 0, all = true;
        cbs.forEach(function(c, n){ if(c.checked){ t += +c.getAttribute('data-p'); } else { all = false; } if(imgs[n]) imgs[n].classList.toggle('off', !c.checked); });
        var d = all ? t * off : 0;
        sum.textContent = kr(t - d);
        save.textContent = all ? 'Du sparar ' + kr(d) + ' när du köper alla' : '';
      }
      cbs.forEach(function(c){ c.addEventListener('change', upd); });
      upd();
      if(reduce) return;
      setInterval(function(){ if(st.v) return; var c = cbs[k]; c.checked = !c.checked; upd(); if(c.checked) k = k === 1 ? 2 : 1; }, 1700);
    });
    root.querySelectorAll('[data-skd-how]').forEach(function(h){
      if(!once(h)) return;
      var s = h.querySelectorAll('.skd-how__s'), i = 0;
      function go(){ s.forEach(function(x, n){ x.classList.toggle('is-on', n === i); }); i = (i + 1) % s.length; }
      go(); if(!reduce) setInterval(go, 1700);
    });
    root.querySelectorAll('[data-skd-vid]').forEach(function(v){
      if(!once(v)) return;
      var cap = v.querySelector('[data-cap]'), caps = (v.getAttribute('data-caps') || '').split('|'), i = 0;
      if(reduce || caps.length < 2) return;
      setInterval(function(){ cap.style.opacity = 0; setTimeout(function(){ i = (i + 1) % caps.length; cap.textContent = caps[i]; cap.style.opacity = 1; }, 400); }, 3000);
    });
    root.querySelectorAll('[data-skd-stock]').forEach(function(s){
      if(!once(s)) return;
      var btns = s.querySelectorAll('[data-q]'), msg = s.querySelector('[data-msg]'), buy = s.querySelector('[data-buy]'), st = stopper(s), i = 0;
      function sel(b){
        btns.forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var q = +b.getAttribute('data-q'), c, txt;
        if(q > 10){ c = '#16A34A'; txt = 'I lager – skickas inom 24 timmar'; }
        else if(q > 0){ c = '#EA580C'; txt = 'Få kvar – ' + q + ' st i lager'; }
        else { c = '#9A9AA4'; txt = 'Slut i lager just nu'; }
        s.style.setProperty('--c', c); s.style.setProperty('--w', Math.max(4, Math.min(100, q / 24 * 100)) + '%');
        msg.textContent = txt; buy.textContent = q > 0 ? 'Lägg i varukorgen' : 'Bevaka – meddela mig';
      }
      btns.forEach(function(b){ b.addEventListener('click', function(){ sel(b); }); });
      sel(btns[0]);
      if(reduce) return;
      setInterval(function(){ if(st.v) return; i = (i + 1) % btns.length; sel(btns[i]); }, 2000);
    });
    root.querySelectorAll('[data-skd-up]').forEach(function(u){
      if(!once(u)) return;
      var list = u.querySelector('.skd-drawer__items'), up = u.querySelector('.skd-up'), add = u.querySelector('[data-add]'), sum = u.querySelector('[data-sum]'), cnt = u.querySelector('[data-count]'), st = stopper(u), base = 499, extra = 99, added = false;
      function bump(){ if(reduce) return; sum.classList.remove('tick'); void sum.offsetWidth; sum.classList.add('tick'); }
      function doAdd(){
        if(added) return; added = true;
        var it = document.createElement('div'); it.className = 'skd-ship__item'; it.setAttribute('data-x', '1');
        it.innerHTML = "<span class='skd-ship__thumb' style='background:linear-gradient(135deg,#7DD3FC,#6B5BFF)'></span><span style='flex:1'>Tillbehör</span><b>99 kr</b>";
        list.appendChild(it); up.classList.add('is-gone'); sum.textContent = kr(base + extra); cnt.textContent = '2 varor'; bump();
      }
      function reset(){ added = false; var x = list.querySelector('[data-x]'); if(x) list.removeChild(x); up.classList.remove('is-gone'); sum.textContent = kr(base); cnt.textContent = '1 vara'; }
      add.addEventListener('click', doAdd);
      reset();
      if(reduce) return;
      (function loop(){ if(st.v) return; setTimeout(function(){ if(st.v) return; doAdd(); setTimeout(function(){ if(st.v) return; reset(); loop(); }, 2800); }, 1500); })();
    });
  }
  function boot(){ init(document); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();